module.exports = require('./jwt-client')(window);



//////////////////
// WEBPACK FOOTER
// ./node_modules/jwt-client/browser.js
// module id = 1090
// module chunks = 18